<template>
    <div class="pda-default">
        <div class="mdc-card mdc-elevation--z3 pda-default" v-if="pointPolicy">
            <div class="t-subtitle2 d-flex flex-row justify-content-between align-items-center">
                <div>
                    {{$t('94')}}
                    <!-- 획득한 포인트 -->
                </div>
                
                <div>
                    <span class="t-subtitle3">Total {{$n(pointPolicy.applicationEarnPoint + pointPolicy.solveAllEarnPoint)}} Points</span>
                    <!-- <span class="t-body3 t-color-bodyGrayA"></span> -->
                </div>
            </div>
            <div class="mgt-16 t-body1">
                <div class="d-flex flex-row justify-content-between align-items-center mgt-16 mgb-16">
                    <img src="@/assets/icon_point.svg" alt="" class="icon">
                    <span class="flex-grow-1 mgr-16 mgl-16 t-color-bodyGrayA">
                        {{$t('97')}}
                        <!-- 응시 완료 포인트 -->
                    </span>
                    <span>
                        {{pointPolicy.applicationEarnPoint}} Points
                    </span>

                </div>

                <div class="d-flex flex-row justify-content-between align-items-center mgt-16 mgb-16">
                    <img src="@/assets/icon_point.svg" alt="" class="icon">
                    <span class="flex-grow-1 mgr-16 mgl-16 t-color-bodyGrayA">
                        {{$t('111')}}
                        <!-- 전 문항 응답 포인트 -->
                    </span>
                    <span>
                        {{pointPolicy.solveAllEarnPoint}} Points
                    </span>

                </div>
            </div>
        </div>

        <div class="mdc-card mdc-elevation--z3 mgt-16 pda-default" v-if="badges.length">
            <div class="t-subtitle2">
                {{$t('112')}}
                <!-- 획득한 배지 -->
            </div>
            <div class="mgt-6">
                <div class="d-flex flex-row justify-content-between align-items-center mgt-16 mgb-16" v-for="(badge, index) in badges" :key="index">
                    <div v-if="badge.image">
                        <img :src="badge.image" alt="" class="badge">
                    </div>
                    <span class="flex-grow-1 mgr-16 mgl-16">
                        {{badge.name}}
                    </span>
                    
                </div>

                
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['pointPolicy','badges'],
}
</script>

<style scoped>

</style>